(function ($) {
  "use strict";

  var kindahl = {
    init: function () {
      this.mainMenuBlock();
      this.mainMenuBlock1();
      this.submenuOpener();
      this.stickyHeader();
      this.heroSlider();
      this.boxSlider();
      this.faqBlock();
    },

    mainMenuBlock: function () {
      jQuery("header").on("click", ".navbar-toggle-btn", function (e) {
        e.preventDefault();
        if (!jQuery(this).hasClass("nav-open")) {
          jQuery("#navbar").removeClass("active");
          jQuery("html").removeClass("menu-active");
          jQuery(this).removeClass("nav-close").addClass("nav-open");
        } else {
          jQuery("#navbar").addClass("active");
          jQuery("html").addClass("menu-active");
          jQuery(this).removeClass("nav-open").addClass("nav-close");
        }
      });
    },

    mainMenuBlock1: function () {
      jQuery("header").on(
        "click",
        ".navbar-toggle-btn.nav-close",
        function (e) {
          jQuery("html").removeClass("submenu-active");
          jQuery(".nav-item").removeClass("opened");
          jQuery(".submenu-opener").removeClass("closed");
          jQuery(".dropdown-menu").css("display", "none");
        },
      );
    },

    submenuOpener: function () {
      jQuery("header.main-header .navbar-nav .submenu-opener").on(
        "click",
        function (e) {
          // e.preventDefault();

          const $this = jQuery(this);

          // CLOSE all other open dropdowns
          jQuery("header.main-header .navbar-nav .submenu-opener")
            .not($this)
            .removeClass("closed")
            .parent(".nav-item")
            .removeClass("opened")
            .find(".dropdown-menu")
            .slideUp();

          // TOGGLE current dropdown
          if (!$this.hasClass("closed")) {
            jQuery("html").addClass("submenu-active");

            $this.addClass("closed");
            $this.parent(".nav-item").addClass("opened");
            $this.next(".dropdown-menu").slideDown();
          } else {
            jQuery("html").removeClass("submenu-active");

            $this.removeClass("closed");
            $this.parent(".nav-item").removeClass("opened");
            $this.next(".dropdown-menu").slideUp();
          }
        },
      );
    },

    stickyHeader: function () {
      jQuery(function () {
        function toggleStickyHeader() {
          var sticky = jQuery("header"),
            scroll = jQuery(window).scrollTop();

          if (scroll >= 1) {
            sticky.addClass("sticky-header");
          } else {
            sticky.removeClass("sticky-header");
          }
        }

        jQuery(window).on("scroll", toggleStickyHeader);
        toggleStickyHeader(); // Trigger once on page load
      });
    },

    heroSlider: function () {
      var $mainslider = $(".hero-slider");

      // Slick Slider Options
      $mainslider.slick({
        draggable: true,
        arrows: true,
        dots: false,
        fade: true,
        infinite: true,
        speed: 300,
        mobileFirst: true,
        pauseOnHover: true,
      });
    },

    boxSlider: function () {
      mobileOnlySlider(".box-slider", true, false, 767);

      function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
        var slider = $($slidername);
        var settings = {
          mobileFirst: true,
          dots: $dots,
          arrows: $arrows,
          autoplay: false,
          infinite: true,
          slidesToShow: 1,

          responsive: [
            {
              breakpoint: $breakpoint,
              settings: "unslick",
            },
          ],
        };

        slider.slick(settings);

        $(window).on("resize", function () {
          if ($(window).width() > $breakpoint) {
            return;
          }
          if (!slider.hasClass("slick-initialized")) {
            return slider.slick(settings);
          }
        });
      } // Mobile Only Slider
    },

    faqBlock: function () {
      $(document).ready(function () {
        function syncDesktopAccordion() {
          if ($(window).width() > 991) {
            // Remove previous bindings
            $("#accordionExample .card-header button").off("click.desktop");

            // Bind new click handler
            $("#accordionExample .card-header button").on(
              "click.desktop",
              function (e) {
                // Get the first ID from data-target (desktop content)
                var targets = $(this).data("target").split(",");
                var desktopTarget = targets[0].trim();

                // Hide all other desktop-only collapse divs
                $(".desktop-only .collapse")
                  .not(desktopTarget)
                  .collapse("hide");

                // Show the clicked one
                $(desktopTarget).collapse("show");

                // Prevent Bootstrap from toggling desktop content automatically
                e.stopPropagation();
              },
            );
          } else {
            // Remove desktop-only bindings on mobile
            $("#accordionExample .card-header button").off("click.desktop");
          }
        }

        // Run on load
        syncDesktopAccordion();

        // Run on resize
        $(window).resize(syncDesktopAccordion);
      });

      $(document).ready(function () {
        // Function to sync aria-expanded for mobile only
        function syncMobileAria() {
          if ($(window).width() <= 991) {
            // For each accordion button
            $("#accordionExample .card-header button").each(function () {
              var targets = $(this).data("target").split(",");
              var mobileTarget = $(targets[1].trim()); // second ID = mobile content

              if (mobileTarget.hasClass("show")) {
                $(this).attr("aria-expanded", "true");
              } else {
                $(this).attr("aria-expanded", "false");
              }
            });
          }
        }

        // Run on collapse show/hide events for mobile
        $("#accordionExample .collapse").on(
          "shown.bs.collapse hidden.bs.collapse",
          function () {
            syncMobileAria();
          },
        );

        // Run on load
        syncMobileAria();

        // Run on resize
        $(window).resize(syncMobileAria);
      });
    },
  };

  kindahl.init();
})(jQuery);
